@if (showHeader) {
  <h4>{{ 'orderProcess.payment.contactForm.title' | translate }}</h4>
}

<payment-contact-info-b
  [userInfo]="info"
  [countryCode]="countryCode"
  [personType]="personType"
  [askForReferenceField]="personType === PAYMENT_PERSON_TYPES.COMPANY"
  (onInfoUpdated)="onInfoUpdated($event)"
  (onValidUpdated)="isValid = $event"
></payment-contact-info-b>

<ng-content select=".gift-card-and-promo-code"></ng-content>


<button class="btn btn-pink payment-confirm-btn my-4"
        [disabled]="!isValid || loading"
        (click)="submit()">
  {{ 'orderProcess.payment.confirmOrder' | translate }}
</button>

<terms-and-conditions
  class="d-block mt-3"
  (onTermsClick)="onTermsClick.emit()"
></terms-and-conditions>
